import React, { Suspense, lazy } from "react";
import CookieConsent from "react-cookie-consent";
import { Route, Routes, HashRouter } from "react-router-dom";
import { observer, useLocalObservable } from "mobx-react-lite";
import { useEffectOnce } from "@lib-shared/hooks";
import "@lib-shared/lib";
import disableConsole from "@lib-shared/lib/disable-console";
import { appSettings } from "core/config";
import { AppContextProvider } from "core/context/app.context";
import { SelfServiceContextProvider } from "core/context/self-service.context";
import { axiosLogger } from "core/instances";
import SelfServiceController from "core/lib/self-service.controller";
import { SessionEvents } from "core/lib/session.manager";
import AppStore from "core/stores/app.store";
import Redirect from "components/redirect";
import AuthStyleWrapper from "components/ui/auth-style-wrapper";
import AccountLayout from "layouts/account.layout";
import MainLayout from "layouts/main.layout";
import RegistrationLayout from "layouts/registration.layout";
import SignInOutLayout from "layouts/sign-in-out.layout";
import SwitchCompany from "self-service/account/switch-company";
import ProcessAuthCode from "self-service/process-auth-code";

if (!appSettings.isEnabled.logToConsole) {
  disableConsole();
}

console.log("appSettings", appSettings)

const selfServiceController = new SelfServiceController();

const App = observer(() => {
  const appStore = useLocalObservable(() => new AppStore());
  const showCookieConsent = false;

  useEffectOnce(() => {
    SessionEvents.OnSetUser = () => {
      console.log("SessionEvents.OnSetUser");
      appStore.initializeUser();
    }

    if (appSettings.isEnabled.logAllResponsesToDatabase) {
      axiosLogger.initialize();
    }
  });

  const DemosLayout = lazy(() => import("./layouts/demos.layout"))
  const ToolsLayout = lazy(() => import("./layouts/tools.layout"))

  return (
    <>
      {/* <div id="root" data-site="business">
        <MenuApp />
      </div> */}

      <AppContextProvider appStore={appStore}>
        <SelfServiceContextProvider value={selfServiceController}>
          <HashRouter>
            <Routes>
              <Route path="/select" element={<AuthStyleWrapper><SwitchCompany /></AuthStyleWrapper>} />
              <Route path="/process/auth-code" element={<ProcessAuthCode />} />
              <Route path="/account/*" element={<AccountLayout />} />
              <Route path="/registration/*" element={<RegistrationLayout />} />
              <Route path="/sign-in" element={<Redirect to="/sign/in" />} />
              <Route path="/sign-out" element={<Redirect to="/sign/out" />} />
              <Route path="/sign/*" element={<SignInOutLayout />} />
              <Route path="/demos/*" element={<Suspense><DemosLayout /></Suspense>} />
              <Route path="/tools/*" element={<Suspense><ToolsLayout /></Suspense>} />
              <Route path="/*" element={<MainLayout />} />
            </Routes>
          </HashRouter>
        </SelfServiceContextProvider>
      </AppContextProvider>
      {showCookieConsent && <CookieConsent
        location="bottom"
        buttonText="Accept Cookies"
        cookieName="cookie_consent_settings_set"
        containerClasses="fixed-bottom card-text smaller-text bg-white text-black d-flex justify-content-between align-items-center"
        buttonClasses="btn btn-outline-black cust-m-1 cust-mr-5 inline-block"
        contentClasses="cust-ml-2"
        disableStyles={true}
        cookieValue="true"
        declineCookieValue="false"
        cookieSecurity={false}
        sameSite="lax"
        expires={150}
      // debug={true} //Use debug to always show Cookie Consent for testing
      >
        MultiChoice Group and its partners use cookies to help deliver
        services and for advertising purposes (see details in&nbsp;
        <a
          className="font-bold underline text-black"
          href="https://www.multichoice.com/privacy-cookie-notice/"
        >
          Privacy Policy
        </a>
        ) By using this site you agree to this. You can change your cookie
        settings in your browser.
      </CookieConsent>}
    </>
  );
});

export default App;
